import PropTypes from "prop-types";
import { Button, ButtonSize, Icon, IconNames } from "@wattpad/web-ui-library";
import React, { useState } from "react";

import { useTrans, useTrapKeyboardNavigation } from "../../../hooks";
import classNames from "classnames";
import { canUseDom } from "../../../helpers";
import { createPortal } from "react-dom";

function OnboardingTooltip(props) {
  const { trans } = useTrans();
  const [tooltipRef, setTooltipRef] = useState(null);

  useTrapKeyboardNavigation(tooltipRef);

  return (
    <div
      className={classNames(props.className, "onboarding-tooltip")}
      role="dialog"
      aria-labelledby="onboarding-tooltip-title"
      aria-describedby="onboarding-tooltip-description"
      aria-modal="true"
    >
      {canUseDom ? (
        createPortal(
          <div className="onboarding-tooltip-overlay" />,
          document.body
        )
      ) : (
        <div className="onboarding-tooltip-overlay" />
      )}
      <div className="tooltip-content" ref={setTooltipRef}>
        {props.showCloseButton && (
          <button className="close-tooltip-button">
            <Icon name={IconNames.WpClose} size={16} />
          </button>
        )}
        <h6 className="tooltip-title" id="onboarding-tooltip-title">
          {props.title}
        </h6>
        <p className="tooltip-text" id="onboarding-tooltip-description">
          {props.text}
        </p>
        <Button
          label={trans("Got it")}
          fullWidth={false}
          size={ButtonSize.SMALL}
          className="confirm-button"
        />
        <div className="arrow" />
      </div>
    </div>
  );
}

OnboardingTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  showCloseButton: PropTypes.bool
};

export default OnboardingTooltip;
